export default {"src":"/_next/static/media/hand.43ebdfee.svg","height":28,"width":25};